import { useQuery } from 'react-query';

import type { BillingPlanHistoryResponseDto } from '../../../../backend/src/organisation/dto/billing-plan-history.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export function useGetOrganisationBillingPlanHistory(orgId: string) {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<BillingPlanHistoryResponseDto[]>(
    [QueryEntity.OrganisationBillingPlanHistory, { orgId }],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/org/${orgId}/billing-plan-history`, fetchConfigGET);
      if (!response.ok) throw new Error('Failed to load billing plan history');
      return response.json();
    },
    { enabled: !!orgId },
  );
}
